import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from '../../common/inputs/customs/switch.jsx';

class UppercaseEnabled extends Component {
  render() {
    return (
      <div>
        <Switch
          title="Tag uppercase words as suspected spam"
          description="Tag sentences and words with upper case letters as suspected spam"
          value={this.props.uppercaseMsgsEnabled}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

UppercaseEnabled.defaultProps = {
  uppercaseMsgsEnabled: true
};

UppercaseEnabled.propTypes = {
  uppercaseMsgsEnabled: PropTypes.bool.isRequired,
  spotId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

UppercaseEnabled.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

UppercaseEnabled.displayName = 'UppercaseEnabled';

export default UppercaseEnabled;
